import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=9cb47150&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButtonIcon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Button/Icon.vue').default,UiSearch: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Search/index.vue').default,Section: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Section/Index.vue').default})
